import z from 'zod';

const schFile = z.instanceof(File);

export type QAUploadDocumentsForm = z.infer<typeof schQAUploadDocumentsForm>;
export const schQAUploadDocumentsForm = z.object({
  reportPDF: schFile,
  orderDetailsPDF: schFile.optional(),
  loePDF: schFile.optional(),
  purchaseContractPDF: schFile.optional(),
});
